export class AuthenticationTokenSet {
  public accessToken?: string;
  public refreshToken?: string;
  public expirationDateInMs?: number;
}

export interface OAuthResponse {
  access_token?: string;
  refresh_token?: string;
  id_token?: string;
  expires_in?: number;
}

export interface OauthJwtPayload {
  iss?: string;
  aud?: string[] | string;
  sub?: string;
  iat?: number;
  exp?: number;
}

export interface IdentityJwtPayload extends OauthJwtPayload {
  mp_email?: string;
  mp_roles?: string[];
  nickname?: string;
  name?: string;
  picture?: string;
  updated_at?: Date;
  email?: string;
  email_verified?: boolean;
}

export interface AccessJwtPayload extends OauthJwtPayload {
  mp_email_verified?: boolean;
  mp_roles?: string[];
  scope?: string;
  gty?: string;
  azp?: string;
  permissions?: string[];
}
